import { fork } from 'redux-saga/effects';

import personalizationSagas from './personalization/sagas';

const scheduleConfirmationSagas = [fork(personalizationSagas)];

export default scheduleConfirmationSagas;
